import httpService from "../../services/httpService";
const bmrSubjectApi = {
  getSubjectList: (
    phase_id,
    page,
    limit,
    searchData,
    editor_id,
    investigator_id,
    status,
    gender,
    orderBy,
    order
  ) =>
    httpService.get(
      `subjectList?phase_id=${
        phase_id || ""
      }&page=${page}&limit=${limit}&searchData=${searchData || ""}&editor_id=${
        editor_id || ""
      }&investigator_id=${investigator_id || ""}&status=[${
        status || ""
      }]&gender=${gender || ""}&sort_by=${orderBy || ""}&order_by=${
        order || "desc"
      }`
    ),
  getSubjectDetails: (id) => httpService.get(`subjectDetails/${id}`),
  getSubjectDetailsWithCryo: (id,fId) => httpService.get(`subjectDetails/${id}?feasibility_id=${fId}`),
  setAppointmentAnswerData: (data) =>
    httpService.post(`saveAppointmentAnswerData`, data),
  subjectStatusDropDown: () => httpService.get("subjectStatusDropDown"),
  addSubject: (data) => httpService.post("addSubject", data),
  editPatientId: (data) => httpService.post("updatePatientId", data),
  editPatient: (data, id) => httpService.post(`updateSubject/${id}`, data),
  archiveChangeRequests: (ids = [], is_archived = 1) => {
  const idsParam = Array.isArray(ids) ? ids.join(',') : ids;
  return httpService.put(`v1/bmr/change-task/archive?ids=${idsParam}`,
    { is_archived }
  );
},
  ///////////////////////addAppointment///////////////////
  addAppointment: (data) => httpService.post("addAppointment", data),
  changeLifeStatus: (data) => httpService.post("changeLifeStatus", data),
  addPatientId: (data) => httpService.post("addPatientId", data),
  requestChange: (data) => httpService.post("add-request-reasons", data),
  getAllRequest: (phase_type) =>
    httpService.get(
      `list-request-reasons${phase_type === "Trial" ? `?phase_type=${phase_type}` : ""}`
    ),
  getAllCategory: () => httpService.get("category-stage-list"),
  getStageList: () => httpService.get("stage-list"),


  tasklist: (limit = 10, page = 1, filter = {}) => {
    const params = new URLSearchParams();
    params.append("per_page", page.toString());
    params.append("limit", limit.toString());
    params.append("sort_order", "desc");

    Object.entries(filter).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        params.append(key, value?.toString());
      }
    });

    const url = `v1/bmr/task/list?${params.toString()}`;
    return httpService.get(url);
  },

  taskTimeline: (subject, limit = 10, page = 1, filter = {}) => {
    const payload = {
      per_page: page,
      limit: limit,
      sort_order: "desc",
      sort_by: null,
      ...filter,
    };

    // Remove null/undefined/empty values if needed
    const cleanPayload = Object.fromEntries(
      Object.entries(payload).filter(
        ([, value]) => value !== null && value !== undefined && value !== ""
      )
    );

    const url = `v1/bmr/task/${subject}/timeline`;
    return httpService.get(url, cleanPayload);
  },

  completeTask: (taskId) => httpService.put(`v1/bmr/task/${taskId}/complete`),

  requestHistory: (limit, page, phase_id, subject_id, filter,feasibility_id,change_request_reason_id,is_archived,is_history = false) =>
    httpService.post(
      `get-request-reasons-list?limit=${limit || "10"}&page=${
        page || "1"
      }&phase_id=${phase_id || ""}&subject_id=${subject_id || ""}&feasibility_id=${feasibility_id || ""}&change_request_reason_id=${change_request_reason_id || ""}&is_archived=${is_archived ?? ""}&is_history=${is_history}`,
      filter
    ),
  archiveTask: (ids = [], is_archived = 1) => {
      const idsParam = Array.isArray(ids) ? ids.join(',') : ids;
    return httpService.put(
      // `v1/bmr/change-request/archive?ids=${ids}`,
      `v1/bmr/change-task/archive?ids=${idsParam}`,
      { is_archived }
    );
  },
  changeRequests: (ids = [], is_archived = 1) => {
    const idsParam = Array.isArray(ids) ? ids.join(',') : ids;
    return httpService.put(
            `v1/bmr/change-request/archive?ids=${idsParam}`,
      { is_archived }
    );
  },

  requestApproval: (payload) =>
    httpService.put(`resolve-request-reasons-query?qr_code_id=${payload?.qr_code_id}`, payload),
  exportRequestList: (payload) =>
    httpService.get(`export-request-reasons-list`, payload),
  exportRequestListById: (payload, id) =>
    httpService.get(`export-request-reasons-list/${id}`, payload),

  presetSubjectData: (id) => httpService.get(`subjectData/${id}`),
};
export default bmrSubjectApi;
